import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { type VestigasHTTPError } from '@vestigas/data';

import { type ContactLink } from '../types';

import { addContactLink } from './addContactLink';

type AddContactLinkMutationOptions = Omit<
  UseMutationOptions<ContactLink, VestigasHTTPError, UUID>,
  'mutationFn'
>;

/**
 * React Query based custom hook for creating a contact link for a data exchange.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Exchange/operation/add_contact_link_data_exchange_contact_link_post
 */
export const useMutationAddContactLink = (
  options?: AddContactLinkMutationOptions,
) => {
  return useMutation({
    mutationFn: async (dataExchangeId) => addContactLink(dataExchangeId),
    throwOnError: false,
    ...options,
  });
};
